import { DbtAsset, WarehouseAsset } from '@/__generated__/graphql';
import { DbtCloudProjectProviderWithParams } from '@/context/DbtCloudProjectProvider';
import { WarehouseProvider } from '@/context/WarehouseProvider';
import { ResourceDetailsPage } from '@/pages/account/project/resource/details/ResourceDetailsPage';
import { parseUniqueId } from '@/typings/parseUniqueId';
import { UrlEnvironmentType } from '@/typings/url';

type MergedAssetDetailPageProps = {
  dbtAsset: DbtAsset | undefined | null;
  warehouseAsset: WarehouseAsset | undefined | null;
};

export const MergedAssetDetailPage = ({
  dbtAsset,
  warehouseAsset,
}: MergedAssetDetailPageProps) => {
  if (!dbtAsset) return null;
  const parsedUniqueId = parseUniqueId(dbtAsset.uniqueId);
  return (
    <DbtCloudProjectProviderWithParams
      params={{
        uniqueId: parsedUniqueId,
        environmentId: Number(dbtAsset.environmentId) ?? 0,
        environmentType: dbtAsset.environmentDeploymentType as UrlEnvironmentType,
        projectId: dbtAsset.projectId,
      }}
    >
      <WarehouseProvider
        warehouseType={warehouseAsset?.warehouseType}
        name={warehouseAsset?.name}
      >
        <ResourceDetailsPage />
      </WarehouseProvider>
    </DbtCloudProjectProviderWithParams>
  );
};
